import { playSound } from '../core/play.js';

function playInputSound() {
    return playSound({
        soundsetName: 'default_textinput',
        action: 'change',
    });
}
function playButtonClickSound() {
    return playSound({
        soundsetName: 'button_secondary',
        action: 'click',
    });
}
function playCheckboxClickSound() {
    return playSound({
        soundsetName: 'check_box',
        action: 'click',
    });
}
function playCardOverSound() {
    return playSound({
        soundsetName: 'button_flat',
        action: 'over',
    });
}
function playCardClickSound() {
    return playSound({
        soundsetName: 'button_flat',
        action: 'click',
    });
}
function playExchangeSound() {
    return playSound({
        soundsetName: 'default_exchange',
        action: 'exchange',
    });
}

export { playButtonClickSound, playCardClickSound, playCardOverSound, playCheckboxClickSound, playExchangeSound, playInputSound };
//# sourceMappingURL=index.js.map
